import Vue from 'vue'
import Router from 'vue-router'
import HomeComponent from '@/views/HomeComponent'
import OptionsComponent from '@/views/OptionsComponent'
import SearchComponent from '@/views/SearchComponent'
import RegisterComponent from '@/views/RegisterComponent'
import QueryComponent from '@/views/QueryComponent'
import LoginComponent from '@/views/LoginComponent'
import ProfileComponent from '@/views/ProfileComponent'
import HelpComponent from '@/views/HelpComponent'
import ContactComponent from '@/views/ContactComponent'
import DocumentationComponent from '@/views/DocumentationComponent'
import UserStoriesComponent from '@/views/UserStoriesComponent'
import VueWordCloud from 'vuewordcloud'
import ProgressBar from 'vuejs-progress-bar'

Vue.component(VueWordCloud.name, VueWordCloud)
Vue.use(ProgressBar)
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: HomeComponent
    },
    {
      path: '/register',
      name: 'Register',
      component: RegisterComponent
    },
    {
      path: '/query',
      name: 'Query',
      component: QueryComponent
    },
    {
      path: '/login',
      name: 'Login',
      component: LoginComponent
    },
    {
      path: '/profile',
      name: 'Profil',
      component: ProfileComponent
    },
    {
      path: '/help',
      name: 'Help',
      component: HelpComponent
    },
    {
      path: '/contact',
      name: 'Contact',
      component: ContactComponent
    },
    {
      path: '/documentation',
      name: 'Documentation',
      component: DocumentationComponent
    },
    {
      path: '/userstories',
      name: 'UserStories',
      component: UserStoriesComponent
    },
    {
      path: '/options',
      name: 'Options',
      component: OptionsComponent
    },
    {
      path: '/search',
      name: 'Search',
      component: SearchComponent
    }
  ],
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js